/**
 * Sleep for given time
 * @param {number} timeout For how long to sleep in MS
 * @returns {Promise}
 */
export default (timeout = 0) => new Promise((resolve) => setTimeout(resolve, timeout));
